import React from 'react';
import { Link } from 'react-router-dom';
import { useSiteConfig } from '../contexts/SiteConfigContext';

export default function Footer() {
  const { config } = useSiteConfig();
  const contact = config.contact;
  const social = config.social;

  const socialLinks = [
    { key: "facebook",  icon: "fa-facebook",  label: "Facebook" },
    { key: "instagram", icon: "fa-instagram", label: "Instagram" },
    { key: "linkedin",  icon: "fa-linkedin",  label: "LinkedIn" },
    { key: "twitter",   icon: "fa-twitter",   label: "X / Twitter" },
    { key: "youtube",   icon: "fa-youtube",   label: "YouTube" },
    { key: "whatsapp",  icon: "fa-whatsapp",  label: "WhatsApp", href: `https://wa.me/${contact.whatsapp}` },
  ];

  return (
    <div>
      <div className='footer'>
        <div className='right'>
          <p>Copyright © {new Date().getFullYear()}, SCI MAYEDO</p>
        </div>
        <div className="foot--content">
          <div className='schedule'>
            <h4 className='footer__title'>Horaire d'ouverture</h4>
            <p>{contact.hours || "Lun–Ven 08h–17h, Sam 09h–13h"}</p>
          </div>

          <div className='address'>
            <h4 className='footer__title'>Contactez-nous</h4>
            <p><i className="fa-solid fa-location-dot"></i> {contact.address}</p>
            <p><i className="fa-solid fa-phone"></i> {contact.phone}</p>
            <p><i className="fa-solid fa-envelope"></i> {contact.email}</p>
          </div>

          <div className='social--media'>
            <h4 className='footer__title'>Réseaux sociaux</h4>
            {socialLinks.map(({ key, icon, label, href }) => {
              const url = href || social[key];
              if (!url) return null;
              return (
                <Link key={key} className='footer--link' to={url} target="_blank" rel="noopener noreferrer">
                  <p><i className={`fa-brands ${icon}`}></i> {label}</p>
                </Link>
              );
            })}
          </div>
        </div>

        <div className='name--developer'>
          <p>Developed by Doumbia Fode (+225 0777880082)</p>
        </div>
      </div>
    </div>
  );
}
